<template>
  <div class="image_bg">
    <div class="form">
      <div class="brand_box_b">
        <div class="brand_name">有朋相册空间</div>
        <div class="brand_dscp">您的朋友 {{groupOwnerName}} 邀请您加入他创建的「{{groupName}}」群组</div>
      </div>
      <div>
        <div class="login_box_b">
          <div class="btn_large" @click="nextStep">加入群组</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'JoinGroupWithInviteCode',
  data: function () {
    return {
      groupId: '',
      inviteCode: '',
      groupName: '',
      groupOwnerName: '',
      currentUserId: null
    }
  },
  async created() {
    try {
      this.groupId =  this.$route.params.groupId
      this.groupName = this.$route.params.groupName
      this.groupOwnerName = this.$route.params.groupOwnerName
      this.inviteCode = this.$route.params.inviteCode
      this.currentUserId = (await this.$faApi.isLogin()).userId

       const isGroupMember = (await this.$faApi.isGroupMember(this.groupId)).isGroupMember
        if (isGroupMember) {
          this.$router.push({ path: `/group/${this.groupId}`})
          return
        }
    } catch (err) {
      this.$faLogger.error('JoinGroupWithInviteCode.vue:created', err)
    }
  },
  methods: {
    async nextStep() {
      try {
        // 判断邀请码是否有效
        const isInviteCodeValid = (await this.$faApi.isInviteCodeValid(this.inviteCode, this.$route.params.groupId)).valid
        if (!isInviteCodeValid) {
          return Toast({ message: '邀请链接失效!' })
        }
        
        if (this.currentUserId) {
          // 如果已经登录，那么直接加入群
          const joinGroupRes = await this.$faApi.joinGroupWithInviteCode(this.inviteCode, this.$route.params.groupId)
          if (joinGroupRes.code === 'INVALID_INVITE_CODE') {
            return Toast({
              message: '邀请链接失效!'
            })
          }
          this.$router.push({ path: `/group/${this.$route.params.groupId}` })
        } else {
          // 如果没有登录, 那么检查是否有accessToken
          localStorage.setItem(this.$faStorage.keys.inviteCode, this.inviteCode)
          localStorage.setItem(this.$faStorage.keys.inviteGroupId, this.$route.params.groupId)
          const accessToken = localStorage.getItem(this.$faStorage.keys.accessToken)
          if (accessToken) {
            // 如果有accessToken，说明用户登录过，跳转去登录
            this.$router.push({ path: '/login_sms' })
          } else {
            // 没有accessToken，那么跳转到首页
            this.$router.push({ path: '/' })
          }
        }
      } catch (err) {
        this.$faLogger.error('JoinGroupWithInviteCode.vue:nextStep', err)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 auto;
    padding: 16px;
    max-width: 320px;
  }
  .header_box {
    position: relative;
    margin: 48px 0;
    text-align: center;
    .title {
      margin: 0;
      font-size: 30px;
      font-weight: bold;
      span {
        font-weight: bold;
      }
    }
    .subtitle {
      margin: 8px 0;
      font-size: 18px;
      font-weight: 300;
      color: white;
    }
  }
  .field {
    margin: 8px 0 0 0;
    width: 100%;
    height: 40px;
    border-width: 0 0 1px 0;
    border-radius: 0;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff8;
    text-align: left;
    font-size: 16px;
    font-weight: 300;
  }
  .btn_large {
    margin: 24px auto 16px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 900;
    text-align: center;
    color: white;
    background-color: red;
    cursor: pointer;
  }
</style>

  